import styled from 'styled-components';
var DrawerHeaderTitle = styled.span.withConfig({
  displayName: "DrawerHeaderstyles__DrawerHeaderTitle",
  componentId: "oycbbr-0"
})(["font-size:", ";"], function (props) {
  return props.theme.font.size['display-1'];
});
export { DrawerHeaderTitle };